/**
 * Browser 相关功能
 * @filename: /home/tujiawei/github/package/packages/web-utils/src/Browser/index.ts
 * @author: Mr Prince
 * @date: 2022-06-19 20:14:25
 */
class Browser {
    /**
     * 网络相关信息
     */
    static getConnection() {
        return navigator.connection;
    }
    /**
     * 可用的逻辑处理器内核数
     */
    static getHardwareConcurrency() {
        return navigator.hardwareConcurrency;
    }
    /**
     * 首选语言
     * 通常是浏览器ui语言
     */
    static getLanguage(defaultLanguage) {
        return navigator.language || defaultLanguage || null;
    }
    /**
     * 用户已知语言的字符串数组
     */
    static getLanguages() {
        return navigator.languages;
    }
    /**
     * 多大同时触摸点数
     */
    static getMaxTouchPoints() {
        return navigator.maxTouchPoints;
    }
    /**
     * 网络状态
     */
    static get online() {
        return navigator.onLine;
    }
    /**
     * 是否在线
     */
    static isOnLine() {
        return Browser.online;
    }
    /**
     * 是否掉线
     */
    static isOffLine() {
        return !Browser.online;
    }
    /**
     * 页面卸载前发送
     * 不一定会成功
     */
    static sendBeacon(url, data) {
        navigator.sendBeacon(url, data);
    }
    /**
     * 浏览器信息
     */
    static getUserAgent() {
        return navigator.userAgent || '';
    }
    /**
     * 判断是否是 ios 手机
     */
    static isIPhone() {
        return /iPhone/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是 ios 平板
     */
    static isIPad() {
        return /iPad/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是 ios pod
     * 这还有浏览器？
     */
    static isIPod() {
        return /iPod/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是苹果系统
     */
    static isIos() {
        return /iPhone|iPad|iPod/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是塞班系统
     */
    static isSymbian() {
        return /Symbian/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是黑莓
     */
    static isBlackBerry() {
        return /BlackBerry/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是安卓系统
     */
    static isAndroid() {
        return /(Android|Linux)/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是windows系统
     */
    static isWindows() {
        return /IEMobile/i.test(Browser.getUserAgent());
    }
    /**
     * 是否在微信浏览器中
     */
    static isWechat() {
        return /MicroMessenger/i.test(Browser.getUserAgent());
    }
    /**
     * 是否在 qq 内置的浏览器中
     */
    static isQQ() {
        return /QQ/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是手机qq浏览器
     */
    static isQQMobile() {
        return /mqqbrowser/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是手机浏览器
     */
    static isMobile() {
        return /AppleWebKit.*Mobile.*/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是 webview
     */
    static isWebview() {
        return (!(/Chrome\/([\d.]+)/i.test(Browser.getUserAgent()) ||
            /CriOS\/([\d.]+)/i.test(Browser.getUserAgent())) &&
            /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(Browser.getUserAgent()));
    }
    /**
     * 是否是电脑端浏览器
     */
    static isPC() {
        return /(Android|iPhone|Windows Phone|SymbianOS|iPad|iPod)/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是IE浏览器
     */
    static isIE() {
        return /Trident/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是 opera
     */
    static isOpera() {
        return /Presto/i.test(Browser.getUserAgent());
    }
    /**
     * 是否 safari 浏览器
     */
    static isSafari() {
        return /Safari/i.test(Browser.getUserAgent());
    }
    /**
     * 内核是否是 webkit
     * Chrome 安卓内置浏览器 opera等
     */
    static isWebkit() {
        return /AppleWebKit/i.test(Browser.getUserAgent());
    }
    /**
     * 是否是火狐浏览器
     */
    static isGecko() {
        return (/Gecko/i.test(Browser.getUserAgent()) &&
            !/KHTML/i.test(Browser.getUserAgent()));
    }
    /**
     * 是否是 oppo 自带的浏览器
     */
    static isOppo() {
        return /HeyTapBrowser/i.test(Browser.getUserAgent());
    }
    /**
     * 是否 web应该程序，没有头部与底部
     */
    static isWebApp() {
        return Browser.isSafari();
    }
}
export default Browser;
//# sourceMappingURL=data:application/json;base64,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